module.exports = __webpack_public_path__ + "static/imac-60594b48e93603cd980f7aa3cf2acebc.png";